import api from "../APIIntercepter";

async function createPaymentAPI(params) {
  const res = await api.post("/payment", params);
  return res.data;
}

async function createCheckoutSessionAPI(params) {
  const res = await api.post("/payment/initiate-payment", params);
  return res.data;
}

export {
  createPaymentAPI,
  createCheckoutSessionAPI,
};

